import {useStaffGuard} from "../../hooks/useStaffGuard.ts";

const WalletStatus = ({
  address,
  chain,
}: {
  chain: { name: string } | undefined;
  address: `0x${string}`;
}) => {
  const formattedAddress = `${address.slice(0, 6)}...${address.slice(-4)}`;
  const {isLoading, role} = useStaffGuard()
  return (
    <div className="mt-2 card bg-base-200 py-2 px-4 rounded-sm shadow-md ">
        <span>{formattedAddress}</span>
        <div className="divider my-0.5" />
        <span className={`text-sm ${isLoading ? "animate-pulse opacity-50" : "opacity-100"}`}>{isLoading ? "Loading..." : `Role: ${role}`}</span>
        <span className="text-sm">{chain ? `Chain: ${chain.name}` : "Chain: Unknown"}</span>
    </div>
  );
};

export default WalletStatus;
